/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateLeadGroupDtoGen,
  MrfiktivLeadGroupControllerGetParamsGen,
  MrfiktivLeadGroupViewModelGen,
  MrfiktivPageViewModelGen,
  MrfiktivUpdateLeadGroupDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class LeadGroup<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags lead group
   * @name LeadGroupControllerCreate
   * @summary (LeadGroup - CREATE) Create a LeadGroup
   * @request POST:/partner/{partnerId}/lead-group
   * @secure
   * @response `201` `MrfiktivLeadGroupViewModelGen` The created lead group
   */
  leadGroupControllerCreate = (partnerId: string, data: MrfiktivCreateLeadGroupDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivLeadGroupViewModelGen, any>({
      path: `/partner/${partnerId}/lead-group`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags lead group
   * @name LeadGroupControllerGet
   * @summary (LeadGroup - READ) Get all lead groups
   * @request GET:/partner/{partnerId}/lead-group
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivLeadGroupViewModelGen)[] })`
   */
  leadGroupControllerGet = (
    { partnerId, ...query }: MrfiktivLeadGroupControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivLeadGroupViewModelGen[] }, any>({
      path: `/partner/${partnerId}/lead-group`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags lead group
   * @name LeadGroupControllerGetOne
   * @summary (LeadGroup - READ) Get a lead group
   * @request GET:/partner/{partnerId}/lead-group/{leadGroupId}
   * @secure
   * @response `200` `MrfiktivLeadGroupViewModelGen` The lead group
   */
  leadGroupControllerGetOne = (partnerId: string, leadGroupId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivLeadGroupViewModelGen, any>({
      path: `/partner/${partnerId}/lead-group/${leadGroupId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags lead group
   * @name LeadGroupControllerUpdate
   * @summary (LeadGroup - UPDATE) Updates a lead group
   * @request PATCH:/partner/{partnerId}/lead-group/{leadGroupId}
   * @secure
   * @response `201` `MrfiktivLeadGroupViewModelGen` The updated lead group
   */
  leadGroupControllerUpdate = (
    partnerId: string,
    leadGroupId: string,
    data: MrfiktivUpdateLeadGroupDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivLeadGroupViewModelGen, any>({
      path: `/partner/${partnerId}/lead-group/${leadGroupId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags lead group
   * @name LeadGroupControllerDelete
   * @summary (LeadGroup - DELETE) Deletes a lead group
   * @request DELETE:/partner/{partnerId}/lead-group/{leadGroupId}
   * @secure
   * @response `200` `MrfiktivLeadGroupViewModelGen` The deleted lead group
   */
  leadGroupControllerDelete = (partnerId: string, leadGroupId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivLeadGroupViewModelGen, any>({
      path: `/partner/${partnerId}/lead-group/${leadGroupId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
}
